import { PageSize } from "./PageSize";

export const pageSizes: PageSize[] = [
  { id: "10", label: "10" },
  { id: "25", label: "25" },
  { id: "50", label: "50" },
  { id: "100", label: "100" },
  { id: "250", label: "250" },
  { id: "500", label: "500" },
  // { id: "-1", label: "All items" },
];
